import { DatePicker } from '@mui/lab';
import { Grid } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { DateTime } from 'luxon';
import { memo } from 'react';
import { PmiTextField } from 'shell/components/shared/text-field';
import * as yup from 'yup';

export const schema = yup.object().shape({});

export interface VoidVerificationMessiVM {
  date?: DateTime | null;
  note?: string;
}

interface AccordionIssuedAssessmentFormProps {
  disabled?: boolean;
  values?: VoidVerificationMessiVM;
  errors?: FormikErrors<VoidVerificationMessiVM>;
  touched?: FormikTouched<VoidVerificationMessiVM>;
  onChange: (
    key: keyof VoidVerificationMessiVM,
    value: VoidVerificationMessiVM[keyof VoidVerificationMessiVM]
  ) => void;
  onChanges: (values: VoidVerificationMessiVM) => void;
  isUnavailability?: boolean;
}

const AccordionIssuedAssessmentFormComponent = ({
  values,
  onChange,
  touched,
  errors,
}: AccordionIssuedAssessmentFormProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <DatePicker
          label="Data accertamento"
          aria-label="Data accertamento"
          value={values?.date || null}
          onChange={(date) => {
            onChange('date', date);
          }}
          disabled
          renderInput={(params) => (
            <PmiTextField
              id="effectiveDate"
              {...params}
              fullWidth
              error={touched?.date && Boolean(errors?.date)}
              helperText={errors?.date}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiTextField
          id="note"
          label="Note"
          aria-label="Note"
          fullWidth
          multiline
          rows={7}
          inputProps={{
            maxLength: '240',
          }}
          onChange={(event) => {
            onChange('note', event.target.value);
          }}
          value={values?.note || ''}
          error={touched?.note && Boolean(errors?.note)}
          helperText={errors?.note}
        />
      </Grid>
    </Grid>
  );
};

AccordionIssuedAssessmentFormComponent.displayName = 'Accordion return issued form component';

const AccordionIssuedAssessmentForm = memo(AccordionIssuedAssessmentFormComponent);

export default AccordionIssuedAssessmentForm;
